'use strict';

var $Error = require('es-errors');

module.exports = function () {
    // see https://code.google.com/p/v8/wiki/JavaScriptStackTraceApi
    var origPrepareStackTrace = $Error.prepareStackTrace;
    $Error.prepareStackTrace = function (_, stack) { return stack; };
    var stack = (new $Error()).stack;
    $Error.prepareStackTrace = origPrepareStackTrace;
    return stack[2].getFileName();
};
